import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import NSSNavbar from './components/NSSNavbar.js';
import Hero from './components/Hero.js';
import About from './components/About.js';
import Services from './components/Services.js';
import Testimonials from './components/Testimonials.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
import Audit from './components/Audit.js';
import InternalAudit from './components/InternalAudit.js';
import TaxAgents from './components/TaxAgents.js';
import CorporateTax from './components/Coporatetax.js';
import VATConsulting from './components/VATConsulting.js';
import Auditax from './components/Auditax.js';
// import Bookkeeping from './components/Bookkeeping.js';


function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <NSSNavbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bookkeeping" element={<Audit />} />
          <Route path="/internalaudit" element={<InternalAudit/>}/>
           <Route path="/taxagents" element={<TaxAgents/>}/>
            <Route path="/corporatetax" element={<CorporateTax/>}/>
               <Route path="/vatconsult" element={<VATConsulting/>}/>
                 <Route path="/audit" element={<Auditax/>}/>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;